import { render, staticRenderFns } from "./ButtonContentPagination.vue?vue&type=template&id=61345d9c"
import script from "./ButtonContentPagination.vue?vue&type=script&lang=js"
export * from "./ButtonContentPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports